import Box from '@totallymoney/ui/components/Box'
import CategoryNavigation from '@totallymoney/ui/components/CategoryNavigation'
import Grid from '@totallymoney/ui/components/Grid'
import theme from '@totallymoney/ui/theme'
import React from 'react'

import { getCategoryLoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'
import { getUnscoredCategoryPath } from '@utils/getUnscoredCategoryPath'

import {
    GetUnscoredCategoriesFilter,
    LoanProductCategory,
    UnscoredLoanProductsCategory,
} from '@appTypes/LoansApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'

import KbaStatusBanner from '@components/KbaStatusBanner'

import { hasKbaScenario } from '@config/kbaScenarioKeys'

import UnscoredTableFilter from '../UnscoredTableFilter'

interface UnscoredTableHeaderProps {
    activeCategory: LoanProductCategory
    onCategoryChange: (category: LoanProductCategory) => void
    onSortChange: (sortKey: string) => void
    categories: UnscoredLoanProductsCategory[]
    filter: GetUnscoredCategoriesFilter
    sortValue: string
}

const UnscoredTableHeader = ({
    categories,
    activeCategory,
    filter,
    onCategoryChange,
}: UnscoredTableHeaderProps) => {
    const { appQueryState, goToRouteWithAppState, getRouteUrl } =
        useAppQueryState()

    const categoryDetails = categories.map(category => ({
        displayName: category.displayName,
        value: category.id,
        url: getRouteUrl(getUnscoredCategoryPath(category.id)),
    }))

    const alternativeProductsCategory = {
        displayName: 'Alternative Products',
        value: LoanProductCategory.AlternativeProducts,
        url: getRouteUrl(
            getUnscoredCategoryPath(LoanProductCategory.AlternativeProducts)
        ),
    }

    const loanFilterLimits = getCategoryLoanFilterLimits(activeCategory)

    return (
        <>
            <Box mb="space20">
                <CategoryNavigation
                    categories={categoryDetails.concat([
                        alternativeProductsCategory,
                    ])}
                    initialActiveCategory={activeCategory}
                    onCategoryChange={category => {
                        goToRouteWithAppState(
                            getUnscoredCategoryPath(
                                category.value as LoanProductCategory
                            ),
                            { shallow: true }
                        )

                        onCategoryChange?.(
                            category.value as LoanProductCategory
                        )
                    }}
                />
            </Box>
            {hasKbaScenario(appQueryState.kbaScenario) ? (
                <Box mb={theme.space30}>
                    <KbaStatusBanner kbaScenario={appQueryState.kbaScenario} />
                </Box>
            ) : null}
            <Grid>
                <Box gridColumn={'1/13'}>
                    <UnscoredTableFilter
                        loanFilterLimits={loanFilterLimits}
                        loanAmount={filter.loanAmount}
                        loanTerm={filter.loanTerm}
                    />
                </Box>
            </Grid>
        </>
    )
}

export default UnscoredTableHeader
